var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{attrs:{"type":"datetimerange","range-separator":"to","start-placeholder":"Start Date","end-placeholder":"End Date"},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})
}
var staticRenderFns = []

export { render, staticRenderFns }